// Data the server already had in hand when it rendered the page, keyed by the
// API URL the page would otherwise fetch. On the server it's set per render
// (rendering is synchronous, so a global is safe); in the browser the layout
// inlines it as window.__PRELOADED__ so hydration paints the same markup the
// server sent, with no loading state and no refetch.
declare global {
  // eslint-disable-next-line no-var
  var __PRELOADED__: Record<string, unknown> | undefined
}

export function peekPreloaded<T>(url: string): T | null {
  return (globalThis.__PRELOADED__?.[url] as T | undefined) ?? null
}
